import React, { useContext, useEffect } from 'react'
import { navigate } from 'gatsby';
import css from '@emotion/css'
import { UrlContext } from '../contexts/UrlContext';
import Layout from 'components/Layout'
import Button from 'components/Button'

export default function Index () {
  const { setQuiz, addAnswer } = useContext(UrlContext);

  const handleClick = role => {
    setQuiz( role );
    addAnswer({
      question: 'Role',
      answer: role,
      url: '/' + `${role}-01`
    });

    navigate(`/${role}-01`);
  };

  const roles = ['engineer', 'contractor', 'wholesaler', 'end-user'];

  return (
    <Layout>
      <h1 css={css`{margin-bottom:48px;}`}>Let us know who you are:</h1>

      { roles.map( role => (
        <Button
          title={role}
          onClick={() => handleClick(role)}
          key={role}
        />
      )) }

    </Layout>
  )
}
